import React, { ReactNode, StrictMode } from 'react';
import { ModalProvider } from '@loglass/loglass-ui/modal';
import { ToastProvider } from '@loglass/loglass-ui/toast';
import { AuthProvider } from '~/common/providers/auth/AuthProvider';
import { LayoutContainer } from '~/app/LayoutContainer';
import { ErrorBoundary } from '~/app/ErrorBoundary';
import { GoogleTagManagerProvider } from '~/app/GoogleTagManagerProvider';
import { AuthGuard } from '~/common/providers/auth/AuthGuard';
import { ZendeskWidgetProvider } from '~/app/ZendeskWidgetProvider';
import { DatadogRumProvider } from '~/app/DatadogRumProvider';
import { LoginUserProvider } from '~/common/providers/auth/LoginUserProvider';
import { LoginUserAuthGuard } from '~/common/providers/auth/LoginUserAuthGuard';
import { TenantProvider } from '~/common/providers/auth/TenantProvider';

type Props = {
  noAuth: boolean;
  children: ReactNode;
};

const CustomAppProvider: React.FC<Props> = ({ children, noAuth }) => (
  <StrictMode>
    <ErrorBoundary>
      {noAuth && children}
      {!noAuth && (
        <AuthProvider>
          <AuthGuard>
            <ToastProvider>
              <TenantProvider>
                <LoginUserProvider>
                  <LoginUserAuthGuard>
                    <DatadogRumProvider>
                      <GoogleTagManagerProvider>
                        <ZendeskWidgetProvider>
                          <ModalProvider>
                            <LayoutContainer>{children}</LayoutContainer>
                          </ModalProvider>
                        </ZendeskWidgetProvider>
                      </GoogleTagManagerProvider>
                    </DatadogRumProvider>
                  </LoginUserAuthGuard>
                </LoginUserProvider>
              </TenantProvider>
            </ToastProvider>
          </AuthGuard>
        </AuthProvider>
      )}
    </ErrorBoundary>
  </StrictMode>
);

export { CustomAppProvider };
